import React from "react";
import get from "lodash/get";
import set from "@rill/set";
import submit from "submit-form";
import getAvatarUrl from "../../../utils/get-avatar-url";
import SettingsNav from "../../../parts/settings-nav";
import ConfirmRemoveCoach from "../../../parts/modals/confirm-remove-coach";
import Avatar from "../../../parts/avatar";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";

function View(props, { locals }) {
  const {
    activeUser,
    coach,
    countries: countryOptions,
    units,
    momentTZ,
  } = locals;
  if (!coach) return null;

  return (
    <main className="settings manage-coaching ">
      <SettingsNav />

      <section>
        <h3>Manage Coach</h3>
        <div className="frame">
          {coach && <label className="mb-2">Your Coach</label>}
          <div className="flex gap-2 items-center">
            <Avatar size={120} url={getAvatarUrl(coach)} className={"image"} />

            <div className="ml-2">
              <h4>{coach.name}</h4>
              {!coach && <p>has requested to be your coach</p>}
            </div>

            <div className="ml-auto">
              {activeUser.coach && (
                <a
                  href={`/dashboard/settings/manage-coaching/?modal[type]=confirm-remove-coach`}
                  role="button"
                  data-button-type="secondary"
                  data-action="cancel"
                >
                  Remove
                </a>
              )}
              {!activeUser.coach && (
                <button
                  onClick={(e) => manageCoach(e, "accept")}
                  data-button-type="primary"
                  type="submit"
                >
                  Accept
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="chip info">
          <div>
            <p>What does this mean?</p>
            <ul>
              <li>
                Your coach will be able to add programs to My Programs that you
                can add to your calendar
              </li>
              <li>
                Your coach will be able to view and make changes to your
                calendar
              </li>
              <li>Your coach will be able to view and share your metrics</li>
            </ul>
          </div>
        </div>
      </section>
    </main>
  );
}

function manageCoach(e, actionToPerform) {
  submit("/dashboard/settings/manage-coaching", {
    method: "POST",
    body: {
      actionToPerform,
    },
  });
}

const ManageCoaching = (app) => {
  app
    .get(
      "/manage-coaching",
      set("heading", "Manage Coach"),
      async ({ req, load, locals, res, api, flash, assert, momentTZ }) => {
        const { activeUser, query } = locals;
        const coach =
          activeUser.coach || get(activeUser, "coachingInvite.coach");
        // Redirect to profile if user has no coach
        if (!coach) return res.redirect("/dashboard/settings/profile");
        const modal = get(query, "modal", {});

        // loads the coach user
        await load("profileUser", { user: coach._id });
        locals.coach = Object.assign({}, coach, locals.profileUser);
        locals.modal = {
          "confirm-remove-coach": <ConfirmRemoveCoach />,
          "activity-feed": <ActivityDrawer />,
        }[modal.type];

        res.body = <View />;
      }
    )
    .post(
      "/manage-coaching",
      async ({ req, locals, res, api, flash, assert, momentTZ }) => {
        const activeUser = locals.activeUser;
        const { body } = req;

        await api("manage-coaching", { method: "PUT", body });
        flash(
          "success",
          `Coach ${
            body.actionToPerform == "accept" ? "accepted" : "removed"
          } successfully.`
        );

        if (body.actionToPerform === "accept") return res.backDontScroll();
        return res.redirect("/dashboard/settings/profile");
      }
    );
};

export default ManageCoaching;
